import * as i0 from '@angular/core';
import { Component, ChangeDetectionStrategy, Directive, Input, NgModule } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { Workflow, EMPTY_ITEM, AdapterPropName, makeDatasource } from 'vscroll';
export { SizeStrategy } from 'vscroll';
import { Subject, BehaviorSubject } from 'rxjs';

var consumer = {
    name: 'ngx-ui-scroll',
    version: '3.0.1'
};

class UiScrollComponent {
    constructor(changeDetector, elementRef) {
        this.changeDetector = changeDetector;
        this.elementRef = elementRef;
        // the only template variable
        this.items = [];
    }
    ngOnInit() {
        this.workflow = new Workflow({
            consumer,
            element: this.elementRef.nativeElement,
            datasource: this.datasource,
            run: (items) => {
                if (!items.length && !this.items.length) {
                    return;
                }
                this.items = items;
                this.changeDetector.detectChanges();
            }
        });
    }
    ngOnDestroy() {
        this.workflow && this.workflow.dispose();
    }
}
UiScrollComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
UiScrollComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.3.11", type: UiScrollComponent, selector: "[ui-scroll]", ngImport: i0, template: `
    <div data-padding-backward></div>
    <div
      *ngFor="let item of items"
      [attr.data-sid]="item.$index"
      [style.position]="item.invisible ? 'fixed' : null"
      [style.left]="item.invisible ? '-99999px' : null">
      <ng-template
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{
          $implicit: item.data,
          index: item.$index,
          odd: item.$index % 2,
          even: !(item.$index % 2)
      }"></ng-template>
    </div>
    <div data-padding-forward></div>`, isInline: true, directives: [{ type: i1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet"] }], changeDetection: i0.ChangeDetectionStrategy.OnPush });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollComponent, decorators: [{
            type: Component,
            args: [{
                    selector: '[ui-scroll]',
                    changeDetection: ChangeDetectionStrategy.OnPush,
                    template: `
    <div data-padding-backward></div>
    <div
      *ngFor="let item of items"
      [attr.data-sid]="item.$index"
      [style.position]="item.invisible ? 'fixed' : null"
      [style.left]="item.invisible ? '-99999px' : null">
      <ng-template
        [ngTemplateOutlet]="template"
        [ngTemplateOutletContext]="{
          $implicit: item.data,
          index: item.$index,
          odd: item.$index % 2,
          even: !(item.$index % 2)
      }"></ng-template>
    </div>
    <div data-padding-forward></div>`
                }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: i0.ElementRef }]; } });

class UiScrollDirective {
    constructor(templateRef, viewContainer, resolver) {
        this.templateRef = templateRef;
        this.viewContainer = viewContainer;
        this.resolver = resolver;
    }
    set uiScrollOf(datasource) {
        this.datasource = datasource;
    }
    ngOnInit() {
        const compFactory = this.resolver.resolveComponentFactory(UiScrollComponent);
        const componentRef = this.viewContainer.createComponent(compFactory, void 0, this.viewContainer.injector);
        componentRef.instance.datasource = this.datasource;
        componentRef.instance.template = this.templateRef;
    }
}
UiScrollDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollDirective, deps: [{ token: i0.TemplateRef }, { token: i0.ViewContainerRef }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Directive });
UiScrollDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "12.0.0", version: "13.3.11", type: UiScrollDirective, selector: "[uiScroll][uiScrollOf]", inputs: { uiScrollOf: "uiScrollOf" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollDirective, decorators: [{
            type: Directive,
            args: [{ selector: '[uiScroll][uiScrollOf]' }]
        }], ctorParameters: function () { return [{ type: i0.TemplateRef }, { type: i0.ViewContainerRef }, { type: i0.ComponentFactoryResolver }]; }, propDecorators: { uiScrollOf: [{
                type: Input
            }] } });

class UiScrollModule {
}
UiScrollModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
UiScrollModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollModule, declarations: [UiScrollComponent,
        UiScrollDirective], imports: [CommonModule], exports: [UiScrollDirective] });
UiScrollModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollModule, providers: [], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.3.11", ngImport: i0, type: UiScrollModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        UiScrollComponent,
                        UiScrollDirective
                    ],
                    imports: [CommonModule],
                    entryComponents: [UiScrollComponent],
                    exports: [UiScrollDirective],
                    providers: []
                }]
        }] });

const getBooleanSubjectPropConfig = () => ({
    source: new Subject(),
    emit: (source, value) => source.next(value)
});
const getItemBehaviorSubjectPropConfig = () => ({
    source: new BehaviorSubject(EMPTY_ITEM),
    emit: (source, value) => source.next(value)
});
const getAdapterConfig = () => ({
    mock: false,
    reactive: {
        [AdapterPropName.init$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.isLoading$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.loopPending$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.firstVisible$]: getItemBehaviorSubjectPropConfig(),
        [AdapterPropName.lastVisible$]: getItemBehaviorSubjectPropConfig(),
        [AdapterPropName.bof$]: getBooleanSubjectPropConfig(),
        [AdapterPropName.eof$]: getBooleanSubjectPropConfig(),
    }
});
const makeAngularDatasource = () => class {
    constructor(_ds) { }
};
const AngularDatasource = makeDatasource(getAdapterConfig);

/**
 * Generated bundle index. Do not edit.
 */

export { AngularDatasource as Datasource, UiScrollDirective, UiScrollModule };
